/* eslint-disable no-undef */
export default class InputMask {
    constructor() {
        this.inputs = null;
        this.tokens = {
            "0": {
                validateRule: /\d/
            },
            "A": {
                validateRule: /[a-zA-Z0-9]/
            },
            "S": {
                validateRule: /[a-zA-Z]/
            }
        };
        this.setInputLength = this.setInputLength.bind(this);
    }

    init() { }

    getInput() {
        this.inputs = document.querySelectorAll("input[data-mask]");
        this.inputs.forEach((input) => {
            input.addEventListener("input", this.maskInput.bind(this));
            input.addEventListener("blur", this.validateInput.bind(this));
        });
    }

    setInputLength(input, mask, prefix = "", suffix = "") {
        if (input.hasAttribute("minlength") && input.hasAttribute("maxlength")) {
            return;
        }

        const maskLength = mask.length + (prefix?.length || 0) + (suffix?.length || 0);
        if (!input.hasAttribute("minlength")) {
            input.minLength = maskLength;
        }

        if (!input.hasAttribute("maxlength")) {
            input.maxLength = maskLength;
        }
    }

    setInputMode(input, mask) {
        if (input.hasAttribute("inputMode")) {
            return;
        }

        const filteredTokens = [...mask].filter((char) => this.tokens[char]);
        const uniqueTokens = [...new Set(filteredTokens)];
        const isOnlyNumericMask = uniqueTokens.length === 1 && uniqueTokens[0] === "0";
        input.inputMode = isOnlyNumericMask ? "numeric" : "text";
    }

    maskInput(event) {
        const self = this;
        const input = event.target;
        input.setCustomValidity("");

        if (event.inputType === "deleteContentBackward") {
            return;
        }

        const mask = input.dataset.mask;
        const prefix = input.dataset.maskPrefix;
        const suffix = input.dataset.maskSuffix;

        self.setInputLength(input, mask, prefix, suffix);
        self.setInputMode(input, mask);

        const unmaskedValue = self.removeMask(mask, input.value, prefix, suffix);
        const isReverse = input.dataset.maskReverse === "true";
        const maskedValue = self.applyMask(
            unmaskedValue,
            mask,
            isReverse,
            prefix,
            suffix
        );

        input.value = maskedValue;
        input.checkValidity();
    }

    removeMask(mask, value, prefix, suffix) {
        if (!mask || !value) {
            return value;
        }

        if (prefix) {
            value = value.replace(prefix, "");
        }

        if (suffix) {
            value = value.replace(suffix, "");
        }

        const allowTokens = Object.keys(this.tokens);
        const allowTokensRegex = new RegExp(`[${allowTokens.join("")}]`, "g");
        const maskLiteralsToRemove = mask.replace(allowTokensRegex, "");
        return value.replace(new RegExp(`[${maskLiteralsToRemove}]`, "g"), "");
    }

    applyMask(unmaskedValue, mask, isReverse, prefix, suffix) {
        if (!unmaskedValue) {
            return unmaskedValue;
        }

        let maskedValue = "";
        let valueIndex = 0;
        let maskChars = mask.split("");

        if (isReverse) {
            unmaskedValue = unmaskedValue.split("").reverse().join("");
            maskChars = maskChars.reverse();
        }

        for (let i = 0; i < maskChars.length; i++) {
            if (this.tokens[maskChars[i]]) {
                const token = this.tokens[maskChars[i]];
                if (
                    new RegExp(token.validateRule).test(
                        unmaskedValue[valueIndex]
                    ) &&
                    unmaskedValue[valueIndex]
                ) {
                    maskedValue += unmaskedValue[valueIndex];
                    valueIndex++;
                } else {
                    break;
                }
            } else {
                maskedValue += maskChars[i];
            }
        }

        if (isReverse) {
            maskedValue = maskedValue.split("").reverse().join("");
            maskedValue = maskedValue.startsWith(".")
                ? maskedValue.substring(1)
                : maskedValue;
        }

        if (prefix) {
            maskedValue = prefix + maskedValue;
        }

        if (suffix) {
            maskedValue = maskedValue + suffix;
        }

        return maskedValue;
    }
}